import { defineStore } from 'pinia'
import {getPlaces} from '@/api/lists.js'
import { db } from '@/firebaseConfig';

export const usePlaceStore = defineStore('places', {
  state: () => ({
    placelist: []
  }),
  actions: {
    createPlaceList(vm) {
      return new Promise((resolve, reject) => {
        getPlaces({ vm }).then((data) => {
          this.placelist = data
          resolve('done')
        }).catch((resp) => {
          reject(resp)
        })
      })
    },
    newPlaceCheck(vm, data) {
      return new Promise((resolve, reject) => {
        if (data) {
          var slugify = require('slugify')
          let placeslug = slugify(data, {
            replacement: '-',
            remove: /[*+~%#.()'"!:@/]/g,
            lower: true
          })
          let ref = db.collection(vm.$placedb).doc(placeslug)
          ref.get().then(doc => {
            if (!doc.exists) {
              ref.set({
                name: data,
                addedby: vm.$store.state.users.username,
                global: false
              })
              resolve(data)
            } else {
              resolve(doc.data().name)
            }
          }).catch(err => {
            reject(err)
          })
        } else {
          resolve(null)
        }
      })
    }
  }
})
